import React, {useEffect} from 'react';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import AccountConstants from '../../../../constants/AccountConstants';
import {
  HistoryComponent,
  HistoryComponentProps,
} from 'src/components/elements/account/newHistoryUI/historyComponent';

const AllHistoryList = (props: HistoryComponentProps | any) => {
  useEffect(() => {
    FirebaseAnalytic.trackEvent(
      'useEffect:componentDidMount',
      'AllHistoryList',
      {
        ...props,
      },
    );
  }, []);
  return <HistoryComponent {...props} historyfilter={AccountConstants.All} />;
};
export default AllHistoryList;
